module.exports = __webpack_public_path__ + "media/images/en-4c70daf4.svg";